<template>
	<div>
		<JobBotQuestionnaire/>
		<ApplicationEducationFan/>
		<ApplicationCareerFan/>
		<ApplicationLanguageFan/>
		<ApplicationSkillSoftwareSpecialFan/>
		<JobEditFan/>
		<JobFuzzyMatrixFan/>
		<JobProfileEditFan/>
		<JobProfileQuestionnaire/>
		<JobProfileFuzzyMatrixFan/>
		<JobResultNoticeFan/>
		<JobResultExclusionJobProfileFan/>
		<JobResultExclusionApplicantFan/>
		<JobResultSendOffFan/>
		<CommunicationContactApplicantFan/>
		<CommunicationContactJobProfileFan/>
		<CommunicationConversationMessageFan/>
		<CommunicationConversationMessageReplyFan/>
		<CommunicationAppointmentFan/>
		<CommunicationAppointmentMoveFan/>
		<JobVitaFan/>
		<JobMatchingFan/>
		<CharacteristicFan/>
		<CharacteristicAdditionFan/>
		<CharacteristicAdditionMatrixFan/>
	</div>
</template>

<script>
import CharacteristicFan from "@/vue/characteristic/Fan"
import CharacteristicAdditionFan from "@/vue/characteristic/addition/Fan"
import CharacteristicAdditionMatrixFan from "@/vue/characteristic/addition/matrix/Fan"
import ApplicationLanguageFan from "@/vue/application/language/Fan"
import ApplicationSkillSoftwareSpecialFan from "@/vue/application/skill-software-special/Fan"
import JobBotQuestionnaire from "@/vue/application/job/bot/Questionnaire"
import ApplicationCareerFan from "@/vue/application/career/Fan"
import ApplicationEducationFan from "@/vue/application/education/Fan"
import JobMatchingFan from "@/vue/application/job/matching/Fan"
import JobVitaFan from "@/vue/application/job/vita/Fan"
import JobEditFan from "@/vue/application/job/edit/Fan"
import JobFuzzyMatrixFan from "@/vue/application/job/fuzzy-matrix/Fan"
import JobProfileEditFan from "@/vue/customer-area/job-profile/edit/Fan"
import JobProfileQuestionnaire from "@/vue/customer-area/job-profile/Questionnaire"
import JobProfileFuzzyMatrixFan from "@/vue/customer/job-profile/fuzzy-matrix/Fan"
import JobResultNoticeFan from "@/vue/job-result/notice/Fan"
import JobResultExclusionJobProfileFan from "@/vue/job-result/exclusion/job-profile/Fan"
import JobResultExclusionApplicantFan from "@/vue/job-result/exclusion/applicant/Fan"
import JobResultSendOffFan from "@/vue/job-result/send-off/Fan"
import CommunicationContactApplicantFan from "@/vue/communication/ContactApplicantFan"
import CommunicationContactJobProfileFan from "@/vue/communication/ContactJobProfileFan"
import CommunicationConversationMessageFan from "@/vue/communication/conversation/message/Fan"
import CommunicationConversationMessageReplyFan from "@/vue/communication/conversation/message/reply/Fan"
import CommunicationAppointmentFan from "@/vue/communication/appointment/Fan"
import CommunicationAppointmentMoveFan from "@/vue/communication/appointment/MoveFan"

export default {

	components: {
		CharacteristicFan,
		CharacteristicAdditionFan,
		CharacteristicAdditionMatrixFan,
		JobBotQuestionnaire,
		JobProfileQuestionnaire,
		JobProfileFuzzyMatrixFan,
		ApplicationCareerFan,
		ApplicationEducationFan,
		JobMatchingFan,
		JobEditFan,
		JobFuzzyMatrixFan,
		JobVitaFan,
		JobProfileEditFan,
		JobResultNoticeFan,
		JobResultExclusionJobProfileFan,
		JobResultExclusionApplicantFan,
		JobResultSendOffFan,
		CommunicationContactApplicantFan,
		CommunicationContactJobProfileFan,
		CommunicationConversationMessageFan,
		CommunicationConversationMessageReplyFan,
		CommunicationAppointmentFan,
		CommunicationAppointmentMoveFan,
		ApplicationLanguageFan,
		ApplicationSkillSoftwareSpecialFan,
	}
}
</script>
